import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PluginLoaderLayoutComponent } from '../../layouts/plugin-loader-layout/plugin-loader-layout.component';
import { PluginLoaderComponent } from './plugin-loader/plugin-loader.component';
import { DefaultSiteSectionsModule } from '../default-site-sections/default-site-sections.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SharedModule } from '../../shared/shared.module';
import { ChatModule } from '../chat/chat.module';
import { TrustpilotReviewSliderModule } from '../../shared/trustpilot-review-slider/trustpilot-review-slider.component';
import { ContactCtaModule } from '../../shared/contact-cta/contact-cta.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CookieConsentModule } from '../cookie-consent/cookie-consent.module';
import { UspPluginModule } from '../../cms/plugins/usp/usp.component';
import { GoogleAnalyticsModule } from '../tracking/google-analytics.module';
import { environment } from '../../../environments/environment';
import { FacebookPixelModule } from '../tracking/facebook-pixel.module';

const routes: Routes = [
    { path: '', component: PluginLoaderLayoutComponent, pathMatch: 'full' },
    { path: '**', component: PluginLoaderLayoutComponent, pathMatch: 'full' },
];

@NgModule({
    declarations: [
        PluginLoaderLayoutComponent,
        PluginLoaderComponent
    ],
    imports: [
        CommonModule,
        [RouterModule.forChild(routes)],
        DefaultSiteSectionsModule,
        AngularSvgIconModule,
        SharedModule,
        ChatModule,
        TrustpilotReviewSliderModule,
        ContactCtaModule,
        NgSelectModule,
        CookieConsentModule,
        UspPluginModule,
        GoogleAnalyticsModule,
        FacebookPixelModule,
    ],
    exports: [
        [RouterModule],
        PluginLoaderComponent
    ]
})
export class PluginLoaderModule {
}
